import React, {useState, useEffect} from 'react';
import {NavLink} from 'react-router'; 
import {meSplitter} from '../../components/Shared/meLayout'
import {CheckControl} from '../../components/Shared/InputControl'
import { Timers, Focused } from '../../components/Timer/Timers'
import TreeView from "../../components/meTree/TreeView"
import TableView from '../../components/meTable/TableView'
import {Read} from '../../components/Shared/Api'
import {Ts} from '../../config/switcher';
import Header from '../Header';

// https://2us.ma/images/Sync-2.jpeg

const Synchronize = ({lang, account, onEtat}) => {
  const app = 'Synchronize'
  const container = 'HomeContainer'
  const [message, Message] = useState('')
  const [search, Search]  = useState("")
  const [cell, Cell] = useState({entity:'', id:0, field:'', value:''})
  const [node, Node] = useState({entity:'', id:0, parent:0})
  const [clip, Clip] = useState({entity:'Clip', id:0})
  const [detail, Detail] = useState('')
  const [layouts, Layouts]= useState([])
  const [colors, Colors]= useState([])
  
  const splitter = new meSplitter("Side", container)
  
  useEffect(()=>{
    if(account.connected) {     
      Read(`/Layout/Colors`,Colors,null,null)
      Read(`/Layout/${container}`,Layouts,null,null)
    }
  },[])

  useEffect(()=>{
    splitter.InitStyle(layouts)
  },[layouts])

  const onNode = (item) => {
    //alert(`entity=${item.entity}, id=${item.id}, parent=${item.parent}`)
    Detail(`/service/${item.entity}/${item.id}`) //;alert(`TableView ${url}`)
    Node(item)
  }


  const onCell = (item) => {
    //console.log(cell)
    Cell(item)
  }

  useEffect(()=>{
    if(node.entity==='Page'){
      Clip({...clip, id:node.id})
    }
    else {
      Clip({...clip, id:0})
    }

  },[node, detail])

        return (
          account.connected ? 
<>
    <Header lang={lang} service={app} account={account} onSearch={Search} />
    <div className="Sides" id={container}
          onMouseDown={e=>splitter.mouseDown(e)} 
          onMouseMove={e=>splitter.mouseMove(e)} 
          onMouseUp={e=>splitter.mouseUp(e)}            
          >

          <div className="side vside" id="SideTree" style={{width: '25%', bottom:0, verticalAlign:'bottom'}}>
            <TreeView app={app} request={'service/Nodes/'+app} onChange={onNode} Message={Message} lang={lang} />
            <NavLink className="ActionLink" to={"/quote"}>{Ts(lang,'plan','extend')}</NavLink>
          </div>

          <div className="side vside" id="SideDetail" style={{width: '55%'}}>
            <TableView node={node} onChange={onCell} Message={Message} request={detail} />
          </div>

          <div className="side vside" id="SideTimer" style={{width: '20%'}}>
            <h2>Synchronize...</h2>
            <CheckControl name='Connected' value={true} />
            <Timers element={0}/>
          </div>
    </div>
</>
: 
<div>
<h2 style={{color:'red'}}>Synchronize...</h2>
<CheckControl name='Connected' value={false}  />
</div>

        )
    }

export default Synchronize;

